module.exports = __webpack_public_path__ + "media/images/site/main_image3-b71d5b6d81af6b9b5122947b0a4adc56.jpg";